import { Article } from '../../types/items';

export function getIncompleteArticles(articles:Article[]) {
  return articles.filter((article) => {
    if (article.ref.video) {
      return article.ref.video.ref.is_processing || article.ref.video.ref.is_uploading;
    }
    return article.ref.document?.ref.is_processing || article.ref.document?.ref.is_uploading;
  });
}
